import { ageLabel } from '../utils/records';
import React from 'react';
import { Table } from 'antd';

/** Keep every field visible; narrow workspaces present each row as a labelled record. */
export default function RecordTable({ columns = [], scroll, className = '', ...props }) {
  const readableColumns = columns.map(column => ({
    ...column,
    minWidth: column.minWidth ?? (typeof column.width === 'number' ? column.width : undefined),
    render: (value, record, index) => {
      const content = column.render ? column.render(value, record, index) : value;
      const patient = column.title === 'Patient' ? record.patient : column.dataIndex === 'name' && record.role === 'patient' ? record : null;
      return patient ? <div>{content}<small>Age: {ageLabel(patient)}</small></div> : content;
    },
    fixed: undefined,
    ellipsis: false,
    onCell: (record, index) => ({
      ...column.onCell?.(record, index),
      'data-label': typeof column.title === 'string' ? column.title : column.key || '',
    }),
  }));
  return <div className="record-table-container"><Table {...props} rowHoverable={false} className={`record-table ${className}`} columns={readableColumns} tableLayout="auto" scroll={undefined} /></div>;
}
